// @flow
import * as React from "react";
import Transition from "./Transition";

import type { TransitionProps as Props } from "./";

const duration = 200;

const defaultStyles = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0
};

const transitionStyles = {
  entered: { opacity: 1 }
};

function Fade(props: Props) {
  return (
    <Transition
      {...props}
      timeout={duration}
      defaultStyles={defaultStyles}
      transitionStyles={transitionStyles}
    />
  );
}

export default Fade;



// WEBPACK FOOTER //
// ./src/components/common/Animations/Fade.js